export default __webpack_public_path__ + "static/media/img-12.5b27304f.png";